module.exports = __webpack_public_path__ + "img/symmetry-ok.5dee4a00.svg";